<template>
	<div class="w-full h-full flex flex-col items-center justify-between">
		<transition
			name="fade"
			mode="out-in"
		>
			<MainContent
				key="main-content"
				class="w-full flex-1 flex flex-col py-4"
			>
				<div
					v-if="selected.partnership_id"
					class="w-full h-full flex justify-around"
				>
					<div
						class="w-full md:w-5/12 h-full flex flex-col items-center justify-center"
					>
						<div class="w-full position-relative mb-0">
							<SearchInput
								class="w-full h-full"
								:search="search"
								@input="search = $event"
							/>
						</div>

						<div
							id="proceedings-list"
							class="flex-1 w-full card"
						>
							<div class="card-body">
								<template v-if="proceedings_loading">
									<div
										class="col d-flex justify-content-center"
									>
										<div
											class="spinner-border text-theme"
											role="status"
										></div>
									</div>
								</template>
								<template v-else>
									<div
										v-if="filteredProceedings.length"
										class="flex flex-col gap-3"
									>
										<div
											v-for="(
												proceeding, index
											) in filteredProceedings"
											:key="index"
											class="select-card with-border"
											@click="
												SelectProceeding(proceeding)
											"
										>
											<label>
												{{ proceeding.nome }}
												<i class="far fa-plus"></i>
											</label>
										</div>
									</div>
									<div
										v-else
										class="text-center"
									>
										Não há procedimentos no convênio
										selecionado.
									</div>
								</template>
							</div>
						</div>
					</div>

					<transition
						name="fade"
						mode="out-in"
					>
						<div class="w-full md:w-5/12">
							<template
								v-if="
									selectedProceedingsInfo.count > 0 &&
									proceedings_loading == false
								"
							>
								<div class="flex flex-col gap-3">
									<div
										v-for="(
											proceeding, index
										) in selected.proceedings"
										:key="index"
										class="select-card with-border"
										@click="RemoveProceeding(proceeding)"
									>
										<label>
											{{ proceeding.nome }}
											<i class="far fa-times"></i>
										</label>
									</div>
								</div>
							</template>
						</div>
					</transition>
				</div>
			</MainContent>
		</transition>
		<transition
			name="fade"
			mode="out-in"
		>
			<InfoBar>
				<div class="w-full flex justify-center items-center gap-3">
					<span class="font-18 leading-tight"> PROCEDIMENTOS </span>
					<span class="text-dark font-24 leading-tight">
						{{ selectedProceedingsInfo.count }}
					</span>
				</div>
			</InfoBar>
		</transition>
	</div>
</template>

<script>
	const _ = window._

	import Helpers from '../../../helpers'
	const helpers = new Helpers()

	import { mapGetters, mapActions } from 'vuex'
	import Swal from 'sweetalert2'
	export default {
		name: 'Proceedings',
		props: {
			label: {
				type: String,
				default: '',
			},
			modality_id: {
				type: [String, Number],
				default: null,
			},
			partnership: {
				type: Object,
				default: null,
			},
			proceedings: {
				type: Array,
				default: null,
			},
			schedule_type: {
				type: Number,
				default: null,
			},
		},
		data() {
			return {
				SCHEDULE_TYPES: {
					PRE_APPOINTMENT: 1,
					URGENT_APPOINTMENT: 2,
					ALL: 3,
				},
				search: '',
				partnerships: [],
				loaded_proceedings: [],
				selected: {
					partnership_id: null,
					proceedings: [],
					schedules: [],
				},
				select_focused: false,
				is_vacancy: false,
				proceedings_loading: false,
			}
		},
		watch: {
			partnership: {
				async handler(val) {
					this.selected.partnership_id = val ? parseInt(val.id) : null

					if (val && val.id) {
						await this.GetProceedings()
					}
				},
				immediate: true,
			},
			proceedings: {
				handler(val) {
					this.selected.proceedings = val
				},
				immediate: true,
			},
			'selected.partnership_id': {
				async handler(val, oldVal) {
					if (oldVal == null) return

					if (val != oldVal) {
						this.selected.proceedings = []
					}
				},
			},
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
			selectedProceedingsInfo() {
				let time = 0

				this.selected.proceedings.map(p => {
					time = parseInt(p.duracao) + time
				})

				return {
					time: time,
					count: this.selected.proceedings.length,
				}
			},
			filteredProceedings() {
				return this.loaded_proceedings.filter(proceeding => {
					let have_schedule = true
					this.selected.schedules = []

					if (this.selected.proceedings.length > 0) {
						have_schedule = false

						let arr = []

						_.forEach(
							_.map(this.selected.proceedings, 'schedules'),
							schedules => {
								arr = _.concat(arr, schedules)
							}
						)

						this.selected.schedules = _.union(
							_.compact(
								_.map(arr, item => {
									if (
										_.filter(arr, { id: item.id }).length ==
										this.selected.proceedings.length
									) {
										return item.id
									}

									return false
								})
							)
						)

						this.selected.schedules = _.map(
							this.selected.schedules,
							schedule => {
								return arr.find(x => x.id == schedule)
							}
						)

						_.forEach(this.selected.schedules, value => {
							if (!have_schedule) {
								have_schedule =
									_.filter(proceeding.schedules, {
										id: value.id,
									}).length > 0
							}
						})
					}

					let find = true

					if (this.search) {
						find = helpers
							.RemoveAcento(proceeding.nome)
							.toLowerCase()
							.includes(
								helpers.RemoveAcento(this.search).toLowerCase()
							)
					}

					return find && have_schedule
				})
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			async GetProceedings() {
				this.proceedings_loading = true

				return window.api
					.call('post', '/get-proceedings', {
						organization_id: this.requester_selected_id,
						modality_id: this.modality_id,
						type: 3,
						partnership_id: this.selected.partnership_id,
						schedule_type: this.schedule_type,
					})
					.then(({ data }) => {
						if (data.response) {
							this.loaded_proceedings = data.proceedings
							this.is_vacancy = data.is_vacancy
						}
					})
					.finally(() => {
						this.proceedings_loading = false
					})
			},
			SelectProceeding(proceeding) {
				this.selected.proceedings.push(proceeding)
			},
			RemoveProceeding(target) {
				let i = false

				this.selected.proceedings = this.selected.proceedings.filter(
					proceeding => {
						if (proceeding.id == target.id && !i) {
							i = true

							return false
						} else {
							return true
						}
					}
				)
			},
			Continue() {
				if (!this.selected.proceedings.length) {
					Swal.fire({
						icon: 'error',
						title: 'ERRO!',
						text: 'VOCÊ PRECISA SELECIONAR ALGUM PROCEDIMENTO PARA CONTINUAR.',
						customClass: {
							container: 'themed',
						},
					})

					return
				}

				if (!this.selected.schedules.length) {
					Swal.fire({
						icon: 'error',
						title: 'ERRO!',
						text: 'NÃO HÁ AGENDAS DISPONIVEIS PARA ESTA COMBINAÇÃO DE PROCEDIMENTOS.',
						customClass: {
							container: 'themed',
						},
					})

					return
				}

				this.selected.partnership = this.partnerships.find(p => {
					return p.id === parseInt(this.selected.partnership_id)
				})

				this.$emit('next', this.selected)
			},
			Previous() {
				this.$emit('previous')
			},
		},
	}
</script>

<style lang="scss" scoped>
	#proceedings-list {
		// bg-light border-no overflow-y-auto
		background-color: var(--gridBackgroundColor);
		border: 1px solid var(--elementsBorderColor);
		overflow-y: auto;
		border-top-left-radius: 0;
		border-top-right-radius: 0;

		.card-body {
			padding: 1rem;
		}
	}

	:deep(.info-bar) {
		span {
			line-height: 1;
		}
	}
</style>
